import type { IRegisterUserDataPayload } from "@/shared/types";

import type { UserDataFormValues } from "../components/UserDataModal/userDataForm";

export const toRegisterUserDataRequest = (values: UserDataFormValues) => {
  const userData: IRegisterUserDataPayload = {
    name: values.name.trim(),
    surname: values.surname.trim(),
    health_professional: values.health_professional,
    ...(values.health_professional && {
      id_profession: values.id_profession ?? undefined,
      id_registration_type: values.id_registration_type ?? undefined,
      registration_number: values.registration_number?.trim() ?? undefined,
      document_number: values.document_number?.trim() ?? undefined,
    }),
  };

  return {
    userData,
    image: values.health_professional
      ? values.signature ?? undefined
      : undefined,
  };
};
